module.exports = __webpack_public_path__ + "static/media/pic3.eeed4ac5.jpg";